





// import { useSelector } from 'react-redux';
// import React, { useState,useEffect } from 'react';
// import { Outlet } from 'react-router-dom';
// import Sidebar from '../components/Sidebar';
// import DashboardHeader from '../components/Headers/DashboardHeader';
// import { Box, useMediaQuery, Drawer } from '@mui/material';
// import useHealthCheck from "../pages/Hooks/HealthCheck";
// import { BASE_URL } from "../components/BaseUrl";
// import { decryptToken } from "../Utlis/Encryption";
// import { useOutletContext } from 'react-router-dom';
// import { useDispatch } from "react-redux";
// import { setProfile } from "../Redux/Slices/profileSlice";  
// const HEADER_HEIGHT = 64;
// const SIDEBAR_WIDTH = 210;

// const DashboardLayout = () => {
//   const dispatch=useDispatch()
//   const [openSidebar, setOpenSidebar] = useState(false);
//   const [openHeaderMenu, setOpenHeaderMenu] = useState(false);
//   const isMobile = useMediaQuery('(max-width:768px)');
//     const [profile, setProfile] = useState(null);
//       const [profileLocal, setProfileLocal] = useState(null);

// const rawEncryptedToken = localStorage.getItem("token");
//   const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
//   useEffect(() => {
//     const fetchProfile = async () => {
//       if (!token) return;
//       try {
//         const res = await fetch(`${BASE_URL}/account-executive/profile`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const data = await res.json();
//         if (!res.ok || data.error) throw new Error(data.message);
//         // ✅ save into Redux so DashboardHeader sees it
//         dispatch(setProfile(data.data.profile));
//         setProfileLocal(data.data.profile);
//       } catch (err) {
//         console.error("❌ Failed to fetch profile:", err);
//       }
//     };
//     fetchProfile();
//   }, [token, dispatch]);

//   return (
//     <Box
//       sx={{
//         display: 'grid',
//         gridTemplateColumns: isMobile ? '1fr' : `${SIDEBAR_WIDTH}px 1fr`,
//         gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
//         height: '100vh',
//         width: '100vw',
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar (Desktop Only) */}
//       {!isMobile && (
//         <Box
//           sx={{
//             gridRow: '1 / span 2',
//             gridColumn: '1 / 2',
//             borderRight: '1px solid #ddd',
//             backgroundColor: '#fff',
//             zIndex: 1200,
//           }}
//         >
//           <Sidebar />
//         </Box>
//       )}

//       {/* Drawer (Mobile Only) */}
//       {isMobile && (
//         <Drawer
//           anchor="left"
//           open={openSidebar}
//           onClose={() => setOpenSidebar(false)}
//         >
//           <Sidebar mobile onClose={() => setOpenSidebar(false)} />
//         </Drawer>
//       )}

//       {/* Header */}
//       <Box
//         sx={{
//           gridColumn: isMobile ? '1 / 2' : '2 / 3',
//           gridRow: '1 / 2',
//           position: 'fixed',
//           top: 0,
//               left: isMobile ? 0 : SIDEBAR_WIDTH, // 👉 align with sidebar
//     width: isMobile ? '100%' : `calc(100% - ${SIDEBAR_WIDTH}px)`,
//         ml:isMobile?0:1,
   
//           zIndex: 1100,
//           backgroundColor: '#fff',
//           borderBottom: '1px solid #ddd',
//         }}
//       >
//         <DashboardHeader
//           isMobile={isMobile}
//           toggleSidebar={() => setOpenSidebar(true)}
//           toggleHeaderMenu={() => setOpenHeaderMenu(!openHeaderMenu)}
//           showHeaderMenu={openHeaderMenu}
//         />
//       </Box>

//       {/* Scrollable Outlet Content */}
//       <Box
//         sx={{
//           gridColumn: isMobile ? '1 / 2' : '2 / 3',
//           gridRow: '2 / 3',
//           overflowY: 'auto',
//           backgroundColor: '#F9FAFB',
//           px: isMobile ? 0.5 : 1.5,
//           py: 2,
//           ml:isMobile?0:1.5,
//         }}
//       >
//         <Outlet  />
//       </Box>
//     </Box>
//   );
// };

// export default DashboardLayout;




// DashboardLayout.js
import { useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import DashboardHeader from '../components/Headers/DashboardHeader';
import { Box, useMediaQuery, Drawer } from '@mui/material';
import { BASE_URL } from "../components/BaseUrl";
import { decryptToken } from "../Utlis/Encryption";
import { setProfile } from "../Redux/Slices/profileSlice";

const HEADER_HEIGHT = 64;
const SIDEBAR_WIDTH = 210;

const DashboardLayout = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openHeaderMenu, setOpenHeaderMenu] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const dispatch = useDispatch();

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  // ✅ Fetch profile on mount and save in Redux
  // Note: Global unread count fetching is now handled by useGlobalUnreadCount hook in App.js
  useEffect(() => {
    const fetchProfile = async () => {
      if (!token) return;
      try {
        const res = await fetch(`${BASE_URL}/account-executive/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.message || "Failed to fetch profile");
        dispatch(setProfile(data.data.profile));
      } catch (err) {
        console.error("❌ Failed to fetch profile:", err);
      }
    };
    fetchProfile();
  }, [token, dispatch]);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : `${SIDEBAR_WIDTH}px 1fr`,
        gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      {/* Sidebar (Desktop Only) */}
      {!isMobile && (
        <Box
          sx={{
            gridRow: '1 / span 2',
            gridColumn: '1 / 2',
            borderRight: '1px solid #ddd',
            backgroundColor: '#fff',
            zIndex: 1200,
          }}
        >
          <Sidebar />
        </Box>
      )}

      {/* Drawer (Mobile Only) */}
      {isMobile && (
        <Drawer
          anchor="left"
          open={openSidebar}
          onClose={() => setOpenSidebar(false)}
        >
          <Sidebar mobile onClose={() => setOpenSidebar(false)} />
        </Drawer>
      )}

      {/* Header */}
      <Box
        sx={{
          gridColumn: isMobile ? '1 / 2' : '2 / 3',
          gridRow: '1 / 2',
          position: 'fixed',
          top: 0,
          left: isMobile ? 0 : SIDEBAR_WIDTH,
          width: isMobile ? '100%' : `calc(100% - ${SIDEBAR_WIDTH}px)`,
          ml: isMobile ? 0 : 1,
          zIndex: 1100,
          backgroundColor: '#fff',
          borderBottom: '1px solid #ddd',
        }}
      >
        <DashboardHeader
          isMobile={isMobile}
          toggleSidebar={() => setOpenSidebar(true)}
          toggleHeaderMenu={() => setOpenHeaderMenu(!openHeaderMenu)}
          showHeaderMenu={openHeaderMenu}
        />
      </Box>

      {/* Scrollable Outlet Content */}
      <Box
        sx={{
          gridColumn: isMobile ? '1 / 2' : '2 / 3',
          gridRow: '2 / 3',
          overflowY: 'auto',
          backgroundColor: '#F9FAFB',
          px: isMobile ? 0.5 : 1.5,
          py: 2,
          ml: isMobile ? 0 : 1.5,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;

